import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import axios from "axios";

Vue.use(Vuex);
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Access-Control-Allow-Headers"] =
  "Origin, X-Requested-With, Content-Type, Accept";

export default new Vuex.Store({
  state: {
    //url: "https://colmenac.ugto.mx/UGC/BuzonUG/",
    url: "https://enjambrec.ugto.mx/UGC/BuzonUG/",
    tipoMensaje: [],
    tipoRelacion: [],
    campus: [],
    division: [],
    esNotificado: false,

    // Menu Izquierdo ---<
    menuList: [
      {
        ruta: "/",
        icon: "mdi-calendar",
        nombre: "Registro",
      },
      {
        ruta: "/Administrador",
        icon: "mdi-account-multiple",
        nombre: "Administrador",
      },
      {
        ruta: "/rutaAlterna2",
        icon: "mdi-school",
        nombre: "Ruta 2",
      },
    ],
    // --->

    // Menu menuDespegable ---<
    msize: "800px",
    mactivo: true,
  },

  mutations: {
    setAuth(state, x) {
      state.Auth = x;
    },

    setTipoMensaje(state, x) {
      console.log("setTipoMensaje", x);
      state.tipoMensaje = x;
    },

    setRelacion(state, x) {
      console.log("setTipoRelacion", x);
      state.tipoRelacion = x;
    },

    setCampus(state, x) {
      console.log("setCampus", x);
      state.campus = x;
    },

    setDivision(state, x) {
      console.log("setDivision", x);
      
      state.division = x;
    },

    setNotificar(state, x) {
      state.esNotificado = true;
    },

    quitarNoti(state, x) {
      state.esNotificado = false;
    },

  },
  actions: {

    obtenerTipoMensaje: async function ({ commit }, x) {
      await axios
        // .get(`${this.state.url2}api/servicios/movil?idPlanUnidad=${'170111'}`, {
        .get(`${this.state.url}TipoMensaje`)
        .then((res) => this.commit("setTipoMensaje", res.data.data))
        // .then((res) => console.log("setTipoMensaje", res.data.data))
        .catch((error) => console.log("setTipoMensaje error", error));
    },

    obtenerRelacion: async function ({ commit }, x) {
      await axios
        // .get(`${this.state.url2}api/servicios/movil?idPlanUnidad=${'170111'}`, {
        .get(`${this.state.url}RelacionUG`)
        .then((res) => this.commit("setRelacion", res.data.data))
        // .then((res) => console.log("setRelacion", res.data.data))
        .catch((error) => console.log("setRelacion error", error));
    },

    obtenerCampus: async function ({ commit }, x) {
      await axios
        // .get(`${this.state.url2}api/servicios/movil?idPlanUnidad=${'170111'}`, {
        //  .get(`https://enjambrec.ugto.mx/CatalogosUG/api/Generales/GetCampus`)
          .get(`https://enjambrec.ugto.mx/UGC/BuzonUG/Campus`)
          .then((res) => (this.commit("setCampus", res.data.data), console.log("CAMPUS",res.data.data)))
        // .then((res) => console.log("setCampus", res.data.data))
        .catch((error) => console.log("setCampus error", error));
    },
    obtenerDivision: async function ({ commit }, x) {
      await axios
        // .get(`${this.state.url2}api/servicios/movil?idPlanUnidad=${'170111'}`, {
        .get(
        //  `https://enjambrec.ugto.mx/CatalogosUG/api/Generales/GetDivisionesBasedByIdCampus?idCampus=${x}`
          `https://enjambrec.ugto.mx/UGC/BuzonUG/Unidad?id_campus=${x}`
        )
        .then((res) => (this.commit("setDivision", res.data.data),console.log("DIVISION",res.data.data)))
        // .then((res) => console.log("setDivision", res.data.data))
        .catch((error) => console.log("setDivision error", error));
    },

    guardaReporte: async function ({ dispatch }, x) {
      console.log(x);
      await axios
        .post(`${this.state.url}BuzonVentanilla`, JSON.stringify(x), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(
          (res) => (
            console.log("guardaReporte", res.data),
            dispatch("enviarMail", res.data.data)
          )
        )
        // .then((res) => console.log("guardaReporte", res.data))
        .catch((error) => console.log("guardaReporte", error));
    },

    enviarMail: async function ({ commit }, x) {
      console.log("enviarMail", x);
      await axios
        .get(`${this.state.url}NotificarUsuario?id_mensaje=${x}`)
        .then(
          (res) => (
            this.commit("setNotificar", true),
            console.log("enviarMail", res.data)
          )
        )
        // .then((res) => console.log("enviarMail", res.data))
        .catch((error) => console.log("enviarMail error", error));
    },
    
  },
});
